import { DEFAULT_TIMEOUT_MS } from "./consts";
import { IControlSource, SocketEventHandler, Subscriber } from "./base";
import { SocketEvent } from "./base";
import { ControlSourceTimeoutHelper } from "./base";
import without from "lodash/without";

class DummySocket extends EventTarget {
  on = (event: SocketEvent, handler: SocketEventHandler) =>
    console.log(`Dummy socket on to ${event} with handler`, handler);
  off = (event: SocketEvent, handler: SocketEventHandler) =>
    console.log(`Dummy socket off to ${event} with handler`, handler);

  emit = (event: SocketEvent, handler: SocketEventHandler) =>
    console.log(`Dummy socket emit to ${event} with handler`, handler);

  close = () => console.log("Dummy socket close");
}

export class DummyControlSource implements IControlSource {
  arcSerial: string;
  socket: DummySocket;
  timeoutHelper: ControlSourceTimeoutHelper;
  errorHandlers: Array<SocketEventHandler>;
  subscribers: { [key: string]: Subscriber[] };
  constructor(arcSerial: string, { timeoutMs = DEFAULT_TIMEOUT_MS } = {}) {
    this.arcSerial = arcSerial;
    this.socket = new DummySocket();
    this.timeoutHelper = new ControlSourceTimeoutHelper(this);
    this.cancelTimeoutOn(["disconnect", "connection", "error"]);
    this.timeoutHelper.schedule(timeoutMs);
    this.errorHandlers = [];
    this.subscribers = {};
  }

  fakeMessage(topic: string, data: any) {
    if (!this.subscribers[topic]) return;
    for (const s of this.subscribers[topic]) {
      setTimeout(() => s(data), 0);
    }
  }

  get nativeSocket() {
    return this.socket;
  }

  isConnected() {
    return true;
  }

  cancelTimeoutOn(events: SocketEvent[] = []) {
    for (const event of events) {
      this.socket.on(event, () => {
        this.timeoutHelper.cancel();
      });
    }
  }

  onDisconnect(cb: SocketEventHandler) {
    this.socket.on("close", cb);
  }

  onConnect(cb: SocketEventHandler) {
    this.socket.on("connection", cb);
  }

  onError(cb: SocketEventHandler) {
    this.socket.on("error", cb);
    this.timeoutHelper.onTimeout(cb);
  }

  close() {
    this.socket.close();
  }

  send = (event: string, data = {}) =>
    console.log(`Dummy sends data to ${event} with data`, data);

  subscribe = (event: string, subscriber: Subscriber) => {
    console.log(`Dummy subscribes to ${event} with handler`, subscriber);
    if (!this.subscribers[event]) this.subscribers[event] = [];
    this.subscribers[event].push(subscriber);
  };

  unsubscribe = (event: string, subscriber: Subscriber) => {
    console.log(`Dummy unsubscribes to ${event} with handler`, subscriber);
    if (!this.subscribers[event]) return;
    without(this.subscribers[event], subscriber);
  };
}

export type DummyControlSourceArgs = ConstructorParameters<
  typeof DummyControlSource
>;
